import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function ManagerAllocationPage() {
  return (
    <SalaryIncreasePlaceholder
      title="My Allocations"
      description="Allocate increases to your team within the approved budget pool."
    />
  );
}
